export class CalibrationData {
  adc_value: number = 0;
  adc_channel_full: number = 0;
  adc_channel_SERCOM: number = 0;
  adc_channel_SERCOM_is_A: boolean = false;
  adc_name: string = "unknow";
  adc_conversion: string = "unknown";
}

